
// Please keep both lists alphabetical.

export const enum FabrixIcon {
    add = 'add',
    aiChat = 'aiChat',
    busy = 'busy',
    calendar = 'calendar',
    cancel = 'cancel',
    clock = 'clock',
    collapse = 'collapse',
    collapseUp = 'collapseUp',
    copy = "copy",
    check = "check",
    chevronLeft = 'chevronLeft',
    chevronRight = 'chevronRight',
    circleCheck = 'circleCheck',
    circleCross = 'circleCross',
    circleInfo = 'circleInfo',
    clipboard = 'clipboard',
    cross = "cross",
    customer = 'customer',
    customerChange = "customerChange",
    defect = 'defect',
    delete = 'delete',
    dialogCancel = 'dialogCancel',
    dialogSave = 'dialogSave',
    dirty = 'dirty',
    documentation = 'documentation',
    doubleCheck = 'doubleCheck',
    down = 'down',
    error = 'error',
    expand = 'expanded',
    expandDown = 'expandDown',
    excel = 'excel',
    export = 'export',
    edit = 'edit',
    fabrix = "fabrix",
    file = "file",
    filter = 'filter',
    filterClear = 'filterClear',
    galleryView = 'galleryView',
    gridView = 'gridView',
    heart = 'heart',
    history = 'history',
    home = 'home',
    import = 'import',
    info = 'info',
    like = "like",
    tileView = 'tileView',
    logout = 'logout',
    key = 'key',
    mail = 'mail',
    menu = 'menu',
    menuDots = 'menuDots',
    modules = 'modules',
    next = 'next',
    notifications = 'notifications',
    partner = 'partner',
    pin = 'pin',
    previous  = 'previous',
    properties = 'properties',
    refresh = 'refresh',
    required = 'required',
    reset  = 'reset',
    resize = 'resize',
    save = 'save',
    search = 'search',
    send = 'send',
    sortAsc = 'sortAsc',
    sortDesc = 'sortDesc',
    sync = 'sync',
    tableView = 'tableView',
    time = 'time',
    unPin = 'unPin',
    unLock = "unLock",
    up = 'up',
    upload = 'upload',

    undo = 'undo',
    user = "user",
    validationDropdown = 'validationDropdown'
}

// Search here. https://remixicon.com/

export const fabrixIcons = {
    add: "ri-add-line",
    aiChat: "ri-chat-ai-line",
    busy: "ri-hourglass-line",
    calendar: 'ri-calendar-line',
    cancel: "ri-close-line",
    clock: "ri-time-line",
    collapse: "ri-subtract-line",
    copy: "ri-file-copy-line",
    check: "ri-check-line",
    chevronLeft: 'ri-arrow-left-s-line',
    chevronRight: 'ri-arrow-right-s-line',
    circleCheck: "ri-checkbox-circle-line",
    circleCross: 'ri-close-circle-line',
    circleInfo: 'ri-information-line',
    clipboard: "ri-clipboard-line",
    cross: "ri-close-line",
    customer: 'ri-building-4-line',
    customerChange: "ri-arrow-right-circle-line",
    defect: 'ri-bug-line',
    delete: 'ri-delete-bin-2-line',
    dialogCancel: 'ri-close-fill',
    dialogSave: 'ri-check-line',
    dirty: 'ri-asterisk',
    documentation: 'ri-article-line',
    down: "ri-arrow-down-fill",
    doubleCheck: 'ri-check-double-line',
    edit: "ri-pencil-line",
    error: 'ri-error-warning-line',
    excel: 'ri-file-excel-2-line',
    expand: "ri-add-line",
    export: "ri-download-2-line",
    fabrix: "ri-bubble-chart-line",
    file: 'ri-file-line',
    filter: 'ri-filter-line',
    filterClear: 'ri-filter-off-line',
    galleryView: 'ri-gallery-view-2',
    gridView: "ri-grid-line",
    heart: "ri-heart-2-line",
    history: 'ri-history-line',
    home: "ri-home-4-line",
    import: 'ri-upload-2-line',
    info: 'ri-info-i',
    like: "ri-thumb-up-line",
    tileView: 'ri-info-card-line',
    logout: "ri-logout-box-line",
    key: "ri-key-2-fill",
    mail: 'ri-mail-line',
    menu: 'ri-menu-line',
    menuDots: 'ri-more-2-line',
    modules: 'ri-apps-line',
    next: 'ri-arrow-right-line',
    notifications: "ri-notification-3-line",
    partner: 'ri-shake-hands-fill',
    pin: "ri-pushpin-line",
    previous: 'ri-arrow-left-line',
    properties: 'ri-list-settings-line',
    refresh: 'ri-refresh-line',
    required: 'ri-star-fill',
    reset: 'ri-reset-left-line',
    resize: "ri-expand-diagonal-2-line",
    save: "ri-save-line",
    search: 'ri-search-line',
    send: 'ri-send-plane-line',
    sortAsc: 'ri-sort-asc',
    sortDesc: 'ri-sort-desc',
    sync: 'ri-loop-right-line',
    tableView: 'ri-table-view',
    time: 'ri-time-line',
    unPin: "ri-unpin-fill",
    unLock: "ri-shield-check-line",
    upload: "ri-upload-line",
    up: "ri-arrow-up-fill",
    undo: 'ri-arrow-go-back-line',
    user: 'ri-user-line',
    validationDropdown: 'ri-arrow-down-s-line'
};




